import { Row } from "@/components";
import clsx from "clsx";
import styles from "../../styles.scss";
import { Person, selectUserData, useBoundStore } from "@/services";

export const TableRow = ({ item }: { item: Person }) => {
  const { user } = useBoundStore(selectUserData);

  return (
    <Row
      className={clsx(
        styles.tableRow,
        styles.tableRow7,
        !item.WorkerOnboardingStatus && styles.isDisabled,
      )}
    >
      <div className={styles.col}>
        <div className={styles.cell} title={item.SupplierId}>
          {item.WorkerEidUnifiedNumber}
        </div>
      </div>
      <div className={styles.col}>
        <div className={styles.cell} title={item.WorkerFullNameArabic}>
          {item.WorkerFullNameArabic}
        </div>
      </div>
      <div className={styles.col}>
        <div className={styles.cell} title={item.WorkerNationality}>
          {item.WorkerNationalityArabic}
        </div>
      </div>
      <div className={styles.col}>
        <div className={styles.cell} title={item.WorkerPassportNumber}>
          {item.WorkerPassportNumber}
        </div>
      </div>
      <div className={styles.col}>
        <div className={styles.cell} title={item.WorkerJobTitleArabic}>
          {item.WorkerJobTitleArabic}
        </div>
      </div>
      <div className={styles.col}>
        <div className={styles.cell} title={`${item.ResidencyAr}`}>
          {item.PlaceOfIssuingResidencePermitArabic}
        </div>
      </div>
      <div className={styles.col}>
        <div className={styles.cell} title={`${item.CompanyAr}`}>
          {user?.Contractor.CompanyNameAr}
        </div>
      </div>
    </Row>
  );
};
